import React, { FC } from 'react';

import { ProductCard } from 'components/product-card';

import { IProductDetailPickerListItemProps } from './types';

/**
 * ProductListItem is a component used to display a product in a given list view.
 * It is a container to display a <Product /> component on the left,
 * AND an optional action on the right which could be either -
 * modifier style, favorite/add, carrot to view more.
 */
export const PickerListItem: FC<React.PropsWithChildren<IProductDetailPickerListItemProps>> = ({
  isFlippable,
  isSelected,
  onProductClick,
  productProps,
  badgeContent,
  badgeContentLeft,
}) => {
  return (
    <ProductCard
      productProps={productProps}
      isSelected={isSelected}
      isFlippable={isFlippable}
      onProductPress={onProductClick}
      badgeContent={badgeContent}
      badgeContentLeft={badgeContentLeft}
      accessibilityRole="radio"
      accessibilitySelected={isSelected}
    />
  );
};
